import { Habit, TaskFilterOptions, Timestamp, User } from '@griply/types';
import { filterHabits, getWeekStartsOn } from '@griply/utils';
import { useMemo } from 'react';

export type UseFilteredHabitsInput = {
  habits: Habit[];
  filters: TaskFilterOptions | TaskFilterOptions[];
  today: Timestamp;
  user: User | null | undefined;
};

export const useFilteredHabits = ({
  habits,
  filters,
  today,
  user,
}: UseFilteredHabitsInput): Habit[] => {
  const weekStartsOn = getWeekStartsOn(user);

  return useMemo(() => {
    const filtersArray = Array.isArray(filters) ? filters : [filters];
    // dev-only timing (RN __DEV__ global) — slow lines mean the planning caches are missed
    const isRnDev = (globalThis as { __DEV__?: boolean }).__DEV__ === true;
    const t0 = isRnDev ? Date.now() : 0;
    const result = filterHabits({
      habits,
      filters: filtersArray,
      weekStartsOn,
      today,
    });
    if (isRnDev && Date.now() - t0 >= 3) {
      // eslint-disable-next-line no-console -- temporary perf instrumentation
      console.log(
        `[perf] ${t0 % 100000} filterHabits ${Date.now() - t0}ms (${habits.length} habits, ${filtersArray.length} filters)`,
      );
    }
    return result;
  }, [filters, habits, today, weekStartsOn]);
};
